module.exports = __webpack_public_path__ + "static/img/all-bg-2.c1fa48c4.png";